import { render, staticRenderFns } from "./AudioFile.vue?vue&type=template&id=42163d68&"
import script from "./AudioFile.vue?vue&type=script&lang=js&"
export * from "./AudioFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports